import { productService } from '../../helpers/productservice/product.service';
import router from '../../router/index'
import Swal from 'sweetalert2';

const user = JSON.parse(localStorage.getItem('user'));

export const state = user
    ? 
        { 
            status: { loggeduser: true }, 
            itemToUpdate:{},
            products:[],
            insumos:[],
        }
    : 
        { 
            status: {}, 
            itemToUpdate: null,
            products:[],
            insumos:[],
        };

export const getters = {
    // Whether the user is currently logged in.
    getitemToUpdate(state) {
        return state.itemToUpdate
    },
    listProducts(state){
        return state.products
    },
    listInsumos(state){
        return state.insumos
    },
}

export const actions = {
    createItem({dispatch, commit}, {objectCreate}){
        productService.createProduct(objectCreate)
        .then(
            result => {
                console.log(result)
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Producto creado.",
                    showConfirmButton: false,
                    timer: 1000
                });
                if (result.item) {
                    commit('mut_setItemToUpdate', result.item)
                }
                commit('setListProducts', [])
                router.push('/products/items');
            },
            error =>{
                console.log(error)
                dispatch('notification/error', error, { root: true });
            }
        )
    },
    setItemToUpdate({commit}, {item}){
        console.log(item)
        commit('mut_setItemToUpdate', item)
    },
    updateItem({dispatch, commit}, {idProduct, objectUpdate}){
        commit('setListProducts', [])
        productService.updateProduct(idProduct, objectUpdate)
        .then(
            result => {
                console.log(result)
                commit('mut_setItemToUpdate', result.item)
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Item actualizado.",
                    showConfirmButton: false,
                    timer: 1000
                });
            },
            error =>{
                console.log(error)
                //commit('loginFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        )
    },
    updateItemAddInsumo({dispatch, commit}, {idProduct, objectUpdate}){
        commit('setListProducts', [])
        productService.updateAddInsumo(idProduct, objectUpdate)
        .then(
            result => {
                console.log(result)
                commit('mut_setItemToUpdate', result.item)
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Item actualizado.",
                    showConfirmButton: false,
                    timer: 1000
                });
            },
            error =>{
                console.log(error)
                //commit('loginFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        )
    },
    removeItemInsumo({dispatch, commit}, {idProduct, objectUpdate}){
        commit('setListProducts', [])
        productService.updateRemoveInsumo(idProduct, objectUpdate)
        .then(
            result => {
                console.log(result)
                commit('mut_setItemToUpdate', result.item)
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Item actualizado.",
                    showConfirmButton: false,
                    timer: 1000
                });
            },
            error =>{
                console.log(error)
                //commit('loginFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        )
    },
    modifyItemInsumo({dispatch, commit}, {idProduct, objectUpdate}){
        commit('setListProducts', [])
        productService.updateModifyInsumo(idProduct, objectUpdate)
        .then(
            result => {
                console.log(result)
                commit('mut_setItemToUpdate', result.item)
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Insumo actualizado.",
                    showConfirmButton: false,
                    timer: 1000
                });
            },
            error =>{
                console.log(error)
                dispatch('notification/error', error, { root: true });
            }
        )
    },
    emptyListProducts({commit}, {item}){
        console.log(item)
        commit('setListProducts', [])
    },
    getAllProducts({dispatch,commit}){
        commit('setListProducts', [])
        productService.listProducts()
        .then(
            result => {
                console.log(result)
                commit('setListProducts', result)
            },
            error => {
                commit('loginFailure', error);
                dispatch('notification/error', error, { root: true });
                router.push('/login');
            }
        )
    },
    getAllInsumos({dispatch,commit}){
        commit('setListInsumos', [])
        productService.listInsumos()
        .then(
            result => {
                console.log("INSUMOS")
                console.log(result)
                commit('setListInsumos', result)
            },
            error => {
                commit('loginFailure', error);
                dispatch('notification/error', error, { root: true });
                router.push('/login');
            }
        )
    },
};

export const mutations = {
    mut_setItemToUpdate(state, item){
        state.itemToUpdate = item
    },
    setListProducts(state, products){
        state.products = products
    },
    setListInsumos(state, insumos){
        state.insumos = insumos
    },
};
